import React, { useCallback, useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { Check, X, Clock } from "lucide-react";

export default function AdminBookings() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = useCallback(() => http.get("/bookings").then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    try {
      await http.patch(`/bookings/${id}/status`, { status });
      toast.success("Aggiornato");
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore");
    }
  };

  const filtered = items.filter((b) => filter === "all" ? true : b.status === filter);
  const badge = (s) => {
    const map = {
      pending: "bg-[var(--mel-primary)] text-white",
      confirmed: "bg-[var(--mel-accent)] text-white",
      rejected: "bg-red-500 text-white",
      cancelled: "bg-[var(--mel-surface)]",
    };
    return map[s] || "bg-[var(--mel-surface)]";
  };

  return (
    <AdminLayout>
      <div className="p-10">
        <div className="eyebrow mb-2">Richieste</div>
        <h1 className="font-serif text-4xl mb-8">Prenotazioni</h1>

        <div className="flex gap-2 mb-6" data-testid="booking-filters">
          {["all", "pending", "confirmed", "rejected", "cancelled"].map((f) => (
            <button key={f} onClick={() => setFilter(f)}
              data-testid={`bfilter-${f}`}
              className={`text-xs uppercase tracking-widest px-4 py-1.5 rounded-full border ${filter === f ? "bg-[var(--mel-text)] text-white border-[var(--mel-text)]" : "border-[var(--mel-border)]"}`}>
              {f}
            </button>
          ))}
        </div>

        <div className="space-y-4">
          {filtered.length === 0 && <div className="text-sm text-[var(--mel-muted)]">Nessuna richiesta.</div>}
          {filtered.map((b) => (
            <div key={b.booking_id} className="border border-[var(--mel-border)] rounded-md p-6 bg-white" data-testid={`booking-${b.booking_id}`}>
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <span className={`text-[10px] uppercase tracking-widest px-2 py-1 rounded-full ${badge(b.status)}`}>{b.status}</span>
                    <span className="font-serif text-lg">{b.property_name}</span>
                  </div>
                  <div className="text-sm">
                    <strong>{b.guest_name}</strong> · {b.guest_email} {b.guest_phone && `· ${b.guest_phone}`}
                  </div>
                  <div className="text-sm text-[var(--mel-muted)] mt-1">
                    <Clock size={12} className="inline mr-1" />
                    {b.check_in} → {b.check_out} · {b.nights} notti · {b.guests} ospiti · €{b.total_price}
                  </div>
                  {b.message && <div className="text-sm mt-3 p-3 bg-[var(--mel-surface)] rounded-md italic">"{b.message}"</div>}
                </div>
                <div className="flex flex-wrap gap-2">
                  {b.status === "pending" && (
                    <>
                      <button onClick={() => setStatus(b.booking_id, "confirmed")} className="mel-btn-primary text-xs" data-testid={`confirm-${b.booking_id}`}><Check size={14} /> Conferma</button>
                      <button onClick={() => setStatus(b.booking_id, "rejected")} className="mel-btn-outline text-xs" data-testid={`reject-${b.booking_id}`}><X size={14} /> Rifiuta</button>
                    </>
                  )}
                  {b.status === "confirmed" && (
                    <button onClick={() => setStatus(b.booking_id, "cancelled")} className="mel-btn-outline text-xs" data-testid={`cancel-${b.booking_id}`}>Annulla</button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
